<div class="modal-header">
  <h5 class="modal-title">
    {{(format === EscalatedTicketUpsertFormat.SIMPLE ? 'Create action and...' : (ticket?.ticket_id ? 'Edit Action' : 'Create Action')) | messageTranslate}}
  </h5>
  <button type="button" class="btn-close" [attr.aria-label]="'Close' | messageTranslate" (click)="cancelSaveTicket()"></button>
</div>

<div class="modal-body">
  @if (format === EscalatedTicketUpsertFormat.SIMPLE) {
    <app-escalated-ticket-simple-upsert #ticketUpsertForm
                                        [site]="site"
                                        [ticket]="asFullTicket(ticket)"
                                        (ticketUpsertData)="onTicketUpsertData($event)"
                                        (loading)="onLoading($event)"
                                        (pending)="onPending($event)"/>
  } @else {
    <app-escalated-ticket-upsert #ticketUpsertForm
                                 [site]="site"
                                 [ticket]="asFullTicket(ticket)"
                                 (ticketUpsertData)="onTicketUpsertData($event)"
                                 (loading)="onLoading($event)"
                                 (pending)="onPending($event)"/>
  }
</div>

<div class="modal-footer">
  <div class="me-auto">
    @if (ticket?.ticket_id) {
      <app-button [visual]="ticket.ticket_archived ? 'warning' : 'danger'"
                  [label]="ticket.ticket_archived ? 'Unarchive' : 'Archive'"
                  [loading]="executingOperation === InProgressOperation.ARCHIVING"
                  [disabled]="executingOperation || loading"
                  (buttonClick)="toggleCurrentActionArchived()"/>
    }
    @if (ticket?.ticket_id && ticket?.ticket_archived) {
      <app-button visual="danger"
                  label="Delete"
                  [loading]="executingOperation === InProgressOperation.DELETING"
                  [disabled]="executingOperation"
                  (buttonClick)="confirmDeleteAction()"/>
    }
  </div>
  <app-button visual="secondary" label="Cancel" [disabled]="executingOperation" (buttonClick)="cancelSaveTicket()"/>
  <app-button type="submit"
              visual="primary"
              [label]="ticket?.ticket_id ? 'Update' : 'Create'"
              [loading]="executingOperation === InProgressOperation.SAVING"
              [disabled]="loading || pending"
              (buttonClick)="saveTicket()"/>
</div>
